module.exports = __webpack_public_path__ + "static/media/marker-hotel-3.e16cea64.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Hotel/images/marker-hotel-3.svg
// module id = 693
// module chunks = 6